module.exports = __webpack_public_path__ + "./images/p27.JPG?d5fd3523dcd000e5c3e5f10c8516c52a";


//////////////////
// WEBPACK FOOTER
// ./src/products/p27.JPG
// module id = 63
// module chunks = 0